const view = {
    state: {
        type:'user',
        user:{
            username: 'admin'
        }
    },
}

const nav = {
    state: {
        isCollapse: false,
    }
}

export {
    view,
    nav
}